import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('No se encontró el elemento #root en el HTML');
}
createRoot(rootEl).render(<React.StrictMode data-id="element-153">
    <App data-id="element-154" />
  </React.StrictMode>);